/**
 * SignUp Page
 * User registration with Clerk components
 * Handles /signup route used by Clerk invitations
 */

import React from 'react';
import { SignUp } from '@clerk/clerk-react';
import { useSearchParams } from 'react-router-dom';

export const SignUpPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const redirectUrl = searchParams.get('redirect_url');

  return (
    <div className="auth-container">
      <div className="flex justify-center">
        <SignUp
          appearance={{
            elements: {
              rootBox: 'mx-auto',
              card: 'shadow-lg',
            },
          }}
          routing="path"
          path="/signup"
          signInUrl="/login"
          // Clerk will use redirect_url from URL if present, otherwise fallback to /dashboard
          fallbackRedirectUrl={redirectUrl || '/dashboard'}
          signInFallbackRedirectUrl={redirectUrl || '/dashboard'}
        />
      </div>
    </div>
  );
};

